import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_NARRATIVE_SEGMENT = gql`
  mutation addOrUpdateNarrativeSegment(
    $input: AddOrUpdateNarrativeSegmentInput!
  ) {
    addOrUpdateNarrativeSegment(input: $input) {
      __typename
      clientMutationId
      errors
      incidentUuid
      narrativeSegmentUuid
      narrativeSegment {
        id
        content
        createdAt
        incident {
          id
        }
        lastUpdatedAt
        lastUpdatedBy {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        lockedBy {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        officer {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
